import { cn } from "@/lib/cn";
import { Icons } from "@/components/ui/icons";

interface MemoryBadgeProps {
  count: number;
  agentName: string;
  className?: string;
}

export function MemoryBadge({ count, agentName, className }: MemoryBadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-frame-memory px-3 py-1 text-canvas-base font-medium shadow-sm text-frame-memory bg-badge-active-fill",
        className,
      )}
      data-testid="memory-badge"
    >
      <Icons.Brain className="h-3 w-3" />
      {agentName} recalled {count} {count === 1 ? "memory" : "memories"}
    </div>
  );
}
